<template>
  <div class="services-box">
    <menuBox :step="3"></menuBox>
    <div class="content-top">
      <div class="title">Liên hệ với chúng tôi</div>
      <div class="text">Liên hệ Vay</div>
    </div>
    <div class="joinUs-box">
      <img src="../assets/services1.png" />
      <div class="info">
        <div class="bt">
          liên hệ với chúng tôi</div>
        <div class="line"></div>
        <div class="title">Làm phim và truyền hình, chúng tôi hiểu bạn hơn. Cùng chúng tôi nhé mọi người
          chụp ảnh được thực hiện đặc biệt dành cho bạn. Cho dù đó là phim, video hay chương trình truyền hình, chúng tôi đều sử dụng quy trình sản xuất
          tính chuyên nghiệp và khả năng sáng tạo không giới hạn để biến câu chuyện của bạn trở thành đỉnh cao của nghệ thuật thị giác.</div>
        <div class="inputBox">
          <input type="text" placeholder="KHÔNG">
          <input type="text" placeholder="Thư">
          <input type="text" placeholder="Điện thoại">
          <textarea class="message" type="text" placeholder="Bài viết về tài khoản" />
          <div class="btn" @click="sendInfo">Gửi tin nhắn</div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    sendInfo() {
      alert('Đã gửi')
    }
  },
};
</script>
<style lang="less" scoped>
.content-top {
  padding: 200px 360px 0;
  background-image: url(../assets/services.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 56px;
    color: #FFFFFF;
    line-height: 79px;
  }

  .text {
    font-weight: bold;
    font-size: 24px;
    color: #E5D806;
    line-height: 33px;
  }
}

.joinUs-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1E1D21;
  padding: 100px 312px;
  box-sizing: border-box;

  img {
    margin-right: 60px;
    width: 600px;
    height: 690px;
  }

  .info {
    padding: 50px;
    width: 640px;
    height: 690px;
    background: #393939;
    box-sizing: border-box;

    .bt {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 33px;
    }

    .line {
      margin-bottom: 16px;
      width: 40px;
      height: 3px;
      background: #E5D806;
    }

    .title {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
    }

    .inputBox {
      input {
        margin-bottom: 10px;
        padding: 20px;
        width: 541px;
        height: 48px;
        background: #5C5C5C;
        box-sizing: border-box;
      }

      textarea {
        padding: 20px;
        width: 541px;
        height: 140px;
        background: #5C5C5C;
        box-sizing: border-box;
      }

      .btn {
        display: table;
        margin-top: 20px;
        padding: 20px 50px;
        background: #E5D806;
        font-weight: 600;
        font-size: 20px;
        color: #1E1D21;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
